import { ComponentPropDefinitionUtil, ComponentPropDefinitions, ComponentProps } from "../../base/ComponentProps";
import { TableRowMode } from "./TableRowMode";
import { Table } from "./Table";
import { HeightWidth } from "@mcleod/core";

export interface TableRowProps extends ComponentProps {
    table: Table;
    allowDelete: boolean;
    allowEdit: boolean;
    data: any;
    expandable: boolean;
    expanded: boolean;
    index: number;
    mode: TableRowMode;
    placeholderHeightWidth: HeightWidth;
    virtualized: boolean;
}

let tableRowProps: ComponentPropDefinitions;

export class TableRowPropDefinitions {
    public static getDefinitions(): ComponentPropDefinitions {
        if (tableRowProps == null) {
            tableRowProps = {
                ...ComponentPropDefinitionUtil.getComponentPropertyDefinitions()
            };
            ComponentPropDefinitionUtil.populateComponentPropNames(tableRowProps);
        }
        return tableRowProps;
    }
}
